import React from "react"
import TutorFeedbackForm from "./TutorFeedbackForm"
import { Image } from "react-bootstrap"
const TutorFeedbackPage = () => {
    return (
        <div>
            <br/>
            <TutorFeedbackForm />
        </div>
    )
}

export default TutorFeedbackPage